import PropTypes from 'prop-types';

export default PropTypes.object;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-leaflet/es/propTypes/layer.js
// module id = 51
// module chunks = 0